<template>
    <main>
        <div class="cover">
			<div class="header" :class="[is_top ? '' : 'active']"></div>
			<div class="header-filter"></div>
			<div class="banner-swiper">
				<div class="swiper-container" id="banner-swiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<div class="banner">
								<div class="center">
									<div class="middle">
										<div class="live" @click="kvToRegister" v-if="!user_info.id">{{ banner_btn.text }}</div>
										<div class="live" @click="toLive" v-if="user_info.id">{{ banner_btn.text }}</div>
									</div>
								</div>
								<div class="logo-box">
									<div class="box"></div>
									<div class="live-btn" v-if="adv5.kv_status" :class="[(adv5.kv_status == 1 && user_info.id) ? 'hidden' : '']" @click="toRegister">{{live_btn}}</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>
			</div>
			<div class="s1">
				<div class="center">
					<div class="content" v-html="adv1.desc"></div>
					<div class="more">
						<div class="btn" @click="kvToRegister" v-if="!user_info.id">{{ banner_btn.text }}</div>
						<div class="btn" @click="toLive" v-if="user_info.id">{{ banner_btn.text }}</div>
					</div>
				</div>
			</div>
			<div class="s2">
				<div class="center">
					<div class="content">
						<div class="left video">
							<video controls id="s1_video" :controls="!s1_play_show" poster="https://dellvideo.smarket.net.cn/66ac51863f7e492fba355f568d82f549/covers/65334635c55c4602b009eabcd53a2f1f-00001.jpg" loop @click.prevent="stopVideo('s1')" src="https://dellvideo.smarket.net.cn/dfa3a86319aa491b9046ac039d575e0c/993f419efa9345878de5c2b6fa524a3f-37b73dc08fa7385d8c1e14a87a1ee8a0-ld.mp4"></video>
							<div class="mark" v-if="s1_play_show">
								<div class="play" @click="playVideo('s1')"></div>
							</div>
						</div>
						<div class="right list">
							<div class="item active">
								<div class="tit">2015年，戴尔科技峰会DTF在中国迈出了具有历史意义的第一步。随后历年，戴尔扎根中国，为客户伙伴持续打造数字化盛宴，助力其从容应对数字化冲击。</div>
								<div class="tit">时光流转至今，2022年的DTF聚焦企业数字化转型进入深水区域的发展现状，通过“数智远见者”之间的优质案例分享，汇集智慧，帮助企业不断提升数字化、智能化能力，开启高韧性企业模式，携手共建商业新磁场。</div>
								<!-- <div class="link"></div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="s3">
				<div class="center">
					<div class="b1"></div>
					<div class="common-title">
						<div class="title">嘉宾介绍</div>
						<div class="en-title">SPEAKER</div>
					</div>
					<div class="content">
						<div class="list">
							<div class="left item" v-for="(item,index) in speaker" v-if="index < 4" :key="index">
								<div class="image">
									<div class="img" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
								</div>
								<div class="info">
									<div class="element username">{{item.username}}</div>
									<div class="element-more desc" v-html="item.job"></div>
								</div>
							</div>
						</div>
						<div class="more" style="display: none">
							<div class="btn" @click="util.toLink('/guest')"><span>查看更多</span></div>
						</div>
					</div>
				</div>
			</div>
			<div class="s4">
				<div class="center">
					<div class="common-title" style="display: none;">
						<div class="title">快捷入口</div>
						<div class="en-title">Convenient navigation</div>
					</div>
					<div class="content">
						<div class="list">
							<div class="left item" @click="util.toLink('/plan')">
								<div class="icon"></div>
								<div class="info">
									<div class="tit">主会场</div>
									<div class="m-tit">KEYNOTE</div>
								</div>
							</div>
							<div class="left item" @click="util.toLink('/branch')">
								<div class="icon"></div>
								<div class="info">
									<div class="tit">分论坛</div>
									<div class="m-tit">BREAKOUT SESSION</div>
								</div>
							</div>

              <div class="left item item-offline" v-if="is_offline" @click="util.toLink('/offline')" >
                <div class="bg"></div>
                <div class="icon"></div>
                <div class="info">
                  <div class="tit">线下活动</div>
                  <div class="m-tit">OFFLINE EVENTS</div>
                </div>
              </div>
              <div class="left item" v-else @click="util.toLink('https://www.dellemc-solution.com/dtfbooth/2026/goglobal')" >
                <div class="bg"></div>
                <div class="icon"></div>
                <div class="info">
                  <div class="tit">线上展区</div>
                  <div class="m-tit">ONLINE BOOTH</div>
                </div>
              </div>

              <div class="left item" @click="util.toLink('/ucenter/plan')" >
                <div class="icon"></div>
                <div class="info">
                  <div class="tit">我的日程</div>
                  <div class="m-tit">MY AGENDA</div>
                </div>
              </div>
						</div>
					</div>
				</div>
			</div>
<!--			<div class="s4_bak" style="display: none">-->
<!--				<div class="center">-->
<!--					<div class="b1"></div>-->
<!--					<div class="content">-->
<!--						<div class=" list">-->
<!--							<div class="left item" @click="util.toLink('/plan')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">主会场</div>-->
<!--									<div class="m-tit">KEYNOTE</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="left item" @click="util.toLink('/branch')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">分论坛</div>-->
<!--									<div class="m-tit">BREAKOUT SESSION</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="left item" @click="util.toLink('/guest')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">嘉宾介绍</div>-->
<!--									<div class="m-tit">SPEAKER</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="left item" @click="util.toLink('/contact/dell')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">联系戴尔</div>-->
<!--									<div class="m-tit">contact dell</div>-->
<!--								</div>-->
<!--							</div>-->

<!--							<div class="left item" v-if="is_offline" @click="util.toLink('')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">线下活动</div>-->
<!--									<div class="m-tit">OFFLINE EVENTS</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="left item" v-else @click="util.toLink('https://www.dellemc-solution.com/dtfbooth/2023/esgs')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">线上展区</div>-->
<!--									<div class="m-tit">ONLINE BOOTH</div>-->
<!--								</div>-->
<!--							</div>-->

<!--							<div class="left item" @click="util.toLink('/interact/download')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">资料下载</div>-->
<!--									<div class="m-tit">RESOURCE LIBRARY</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="left item" @click="util.toLink('/honored')" >-->
<!--								<div class="bg"></div>-->
<!--								<div class="icon"></div>-->
<!--								<div class="info">-->
<!--									<div class="tit">专家面对面</div>-->
<!--									<div class="m-tit">TALK TO EXPERT</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<div class="s2" v-if="is_offline && adv2.length > 0">
				<div class="center">
					<div class="common-title">
						<div class="title">线下活动</div>
						<div class="en-title">OFFLINE EVENTS</div>
					</div>
					<div class="content">
						<div class="left video">
							<video controls id="s2_video" :poster="require('@/assets/image/2022/20220803001_video.jpg')" loop @click.prevent="stopVideo('s2')" src="https://dellvideo.smarket.net.cn/045f032b2e9243b699ae5160993b071d/2bafcc4ed54144998bc02edb775f8aa0-1aa1e196881414ebcb3e345daf76fdf5-ld.mp4"></video>
							<div class="mark" v-if="s2_play_show">
								<div class="play" @click="playVideo('s2')"></div>
							</div>
						</div>
						<div class="right list">
							<div class="item active">
								<div class="tit s2_offline">2026 戴尔科技峰会暨「进化者」论坛将在上海及 3 个卫星城市 北京 / 广州 / 青岛 同时开启线下创新之旅！</div>
								<div class="tit">本届峰会聚焦企业级 AI 从 “技术探索期” 迈向 “规模应用与价值兑现期” 的关键节点，探讨中国企业在全球化深水区面临的数字化转型挑战与破局路径。将从推动 AI 落地见效、重构成本模型、打造 AI 原生工作方式、构建可信智能体系、夯实全球化数字化底座五大维度。与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。</div>
								<!-- <div class="link"></div> -->
							</div>
						</div>
						<div class="more">
							<div class="btn" @click="util.toLink('/offline')"><span>查看更多</span></div>
						</div>
					</div>
				</div>
			</div>
			<div class="s5" v-if="false">
				<div class="center">
					<div class="b1"></div>
					<div class="common-title">
						<div class="title">精彩内容</div>
						<div class="en-title">WHAT TO EXPECT</div>
					</div>
					<div class="content">
						<div class="list">
							<div class="item" v-for="(item,index) in adv4" v-if="index < 3">
								<div class="image-box">
									<div class="image" :style="{backgroundImage:'url('+(item.image ? util.autoImage(item.image): util.autoImage(item.url)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast')+')'}"><div class="play" @click="showVideo(item)"></div></div>
								</div>
								<div class="info">
									<div class="tit">{{item.category_title}}</div>
									<div class="element-more min-tit
">{{item.title}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="more" style="display: none;">
						<div class="btn" @click="util.toLink('/video')"><span>查看更多</span></div>
					</div>
				</div>
			</div>
			<div class="s6" v-show="!is_end">
				<div class="center">
					<div class="b1"></div>
					<div class="common-title" style="display: none;">
						<div class="title">赶快报名参加会议吧</div>
						<div class="en-title">Sign up for the meeting</div>
					</div>
					<div class="content">
						<div class="list">
							<div class="cen">
								<div class="left item">
									<div class="number-box">
										<div class="wrapper">
											<canvas id="bar-day"></canvas>
										</div>
										<div class="number">{{cut_time.day}}</div>
									</div>
									<div class="tit">天</div>
								</div>
								<div class="left item">
									<div class="number-box">
										<div class="wrapper">
											<canvas id="bar-hour"></canvas>
										</div>
										<div class="number">{{cut_time.hour}}</div>
									</div>
									<div class="tit">时</div>
								</div>
								<div class="left item">
									<div class="number-box">
										<div class="wrapper">
											<canvas id="bar-min"></canvas>
										</div>
										<div class="number">{{cut_time.min}}</div>
									</div>
									<div class="tit">分</div>
								</div>
								<div class="left item">
									<div class="number-box">
										<div class="wrapper">
											<canvas id="bar-second"></canvas>
										</div>
										<div class="number">{{cut_time.seconds}}</div>
									</div>
									<div class="tit">秒</div>
								</div>
							</div>
						</div>
						<div class="tip">精彩不容错过，戴尔科技集团期待您的参与</div>
						<div class="more">
							<!-- <div class="btn" @click="bottomToRegister"><span>直播回放</span></div> -->
							<div class="btn" @click="toLive"><span>直播回放</span></div>
						</div>
					</div>
				</div>
			</div>
			<sponsor></sponsor>
		</div>
        <div class="book-success" v-if="book_success">
            <div class="mark"></div>
            <div class="content">
                <div class="close" @click="book_success = false;"></div>
                <div class="middle">
                    <div class="title">{{book_info.title}}</div>
                    <div class="m-title" v-html="book_info.desc"></div>
                </div>
            </div>
        </div>
        <video-float v-if="video_info.category_title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
    </main>
</template>

<script>
import VideoFloat from "../../components/pc/VideoFloat";
import Sponsor from "@/components/pc/Sponsor";
import Bar from 'mini-circle-progress-bar'
export default {
	name: 'home',
	data() {
		return {
			query:"",
			s1_play_show:true,
			s2_play_show:true,
			logo:[require('@/assets/image/49.png'),require('@/assets/image/50.png')],
			swiper:"",
			room_list:[],
			adv2:[],
			adv2_index:0,
			adv3:"",
			adv4:[],
			adv5:{
				kv_status:1
			},
			adv6:{},
			book_success:false,
			book_info:{},
			video_info:{},

			speaker:[],
			is_top:true,
			cut_time:{
				day:0,
				hour:0,
				min:0,
				seconds:0
			},
			is_end:false,
		}
	},
	components:{
		VideoFloat,Sponsor
	},
	computed:{
		adv1(){
			var _text = {
               	"title":"大会介绍",
				"desc":`<p> 2026年，企业级AI已从“技术探索期”迈入 “规模应用与价值兑现期” 。技术正在重构企业运营方式，驱动决策自动化、流程重塑与业务模式创新。多数企业虽已启动AI布局，真正实现可规模复制、可衡量ROI的企业仍属少数。进化差距，正在迅速扩大。与此同时，中国企业全球化迈入深水区。从规模扩张走向高质量增长，从单点突破走向系统化本地运营，企业对数字底座、数据治理与安全合规提出了前所未有的要求。</p>
                <p>在这一关键节点，我们诚挚邀请您出席：<i>2026 戴尔科技峰会暨「进化者」论坛</i>，与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。</p>
                <p>峰会核心价值：</p>
                <p>让AI落地见效，驱动业务增长：构建融合算力、数据与安全的AI原生底座，加速智能体在核心业务中的规模化应用，实现可量化回报。</p>
                <p>重构成本模型，进入Token经济时代：从算力投入走向精细化管理，优化AI成本结构，提升每一分投入的产出效率。</p>
                <p>释放组织生产力，打造AI原生工作方式：以AI PC与终端算力为支点，让AI能力普惠到每一位员工，提升整体决策与执行效率。</p>
				<p>构建可信AI体系，平衡创新与安全：以主权AI与零信任架构为核心，确保数据安全、模型可靠与智能体行为可控。</p>
				<p>支持全球化发展，夯实数字化底座：以一致架构与本地合规能力，助力企业实现高质量全球化运营。</p>`
			};
			// if(this.util.isOffline()){//线下
			// 	_text = {
			// 		"title":"大会介绍",
			// 		"desc":`<p>2024“重启复苏”之年，创新成为经济增长新驱动力。随着经济、技术和社会环境的变化，企业的机遇与挑战并存，可谓既有风口也有浪尖，而数字技术的价值在这个关键时刻则进一步凸显，<i>复苏亟须抓住“突破性创新”关键</i>。</p><p>“数实融合”作为数字化转型的主题核心，也是未来五年数字化转型和高质量发展的主要趋势（IDC）。企业需要在<i>“韧性”和“混合创新力”</i>的双驱动升级下，寻求“稳中制胜”的关键，通过在技术、管理和商业模式上持续提升，开辟新的业务增长点，为企业行稳致远、高质量发展夯实基础。</p><p>风物长宜放眼量，<i>创新是企业赖以生存发展的灵魂，是企业持续发展的保证</i>。戴尔科技集团作为持续深耕数实融合、以“务实的创新”为根本的践行者，通过全面的数字化服务能力和世界级创新技术，聚焦企业当前发展面临的<i>几大核心挑战</i>：</p><p>1.<i>降本增效</i>提升产出，找到新业务增长点</p><p>2.企业出海<i>全球化布局</i>，全球化运营可视化、合规化</p><p>3.区域化深耕服务多样化，<i>业务场景愈发复杂</i>，亟须高度灵活IT架构，打造末端灵活</p><p>4.数据价值挑战，<i>让数据真正流动起来</i></p><p>5.勒索攻击、数据泄露、供应链攻击高发，<i>安全</i>成为制约企业健康发展的生命线</p><p>我们希望与众多的数字决策者们一起深度挖掘数字业务的新动能，预见技术世界的新秩序，开辟数实融合的新格局。</p><p>8月18日，<i>“2024戴尔科技峰会”</i>如约而至。本次峰会以<i>“新·生万物 数实新格局”</i>为主题，届时，戴尔科技集团携手各行业的创新力量为您<i>深入剖析数实融合的成功案例和最佳实践，深度自动化、智能化、云化和边缘加速的创新路径，共同探索在新格局下的发展趋势和机遇</i>。衷心邀请您参与本届创新峰会，共同加速“新·生万物数实新格局”的创新之旅。</p>`
			// 	}
			// }
			return _text;
		},
        is_offline(){
            return this.util.isOffline();
        },
		live_btn(){
			var status = this.adv5.kv_status;
			var text = "";
			if(status == 1){
				if(this.user_info.id){
					text = "大会直播敬请期待"
				}else{
					text = "立即报名"
				}
			}
			if(status == 2){
				text = "正在直播"
			}
			if(status == 3){
				text = "直播回放"
			}
			return text;
		},
		banner_btn(){
			var myDate = parseInt(new Date().getTime()/1000);
			if(myDate < this.tool.date.strtotime('2026-08-21 09:00:00')){
				return {
					// text:'敬请期待',
					link:this.user_info.id ? '/' : "/login",
					text:this.user_info.id ? "敬请期待" : '立即报名',
				}
			}else if(myDate >= this.tool.date.strtotime('2026-08-21 09:00:00') && myDate < this.tool.date.strtotime('2026-08-21 12:00:00')){
				return {
					text:"大会正在直播",
					link:"/plan"
				}
			}else if(myDate >= this.tool.date.strtotime('2026-08-21 12:00:00') && myDate < this.tool.date.strtotime('2026-08-22 00:00:00')){
				return {
					text:"大会正在直播",
					link:"/branch"
				}
			}else{
				return {
					text:"观看大会回放",
					link:"/plan"
				}
			}
		},
		user_info(){
			return this.$store.state.user_info;
		},
	},
	methods: {
		bannerLink(item){
			gio('track', 'DTF2021_homekv_videoplay');
			// this.util.showWait(true);
			// return false;

			if(item.link){
				window.location.href = item.link;
			}
		},
		toLive(){
			gio('track', 'DTF2021_homekv_Watchlive');
			if(this.banner_btn.link){
				this.util.toLink(this.banner_btn.link);
			}
			var myDate = parseInt(new Date().getTime()/1000);
			// if(myDate < this.tool.date.strtotime('2026-08-21 12:00:00') || myDate >= this.tool.date.strtotime('2026-08-23 00:00:00')){
			if(myDate < this.tool.date.strtotime('2026-08-21 12:00:00')){
				// this.util.toLink('/plan');
       			 this.$router.push("/plan");
			}else{
				this.util.toLink('/branch')
			}
		},
		listenScroller(){
			window.onscroll = ()=> {
				this.is_top = !(document.documentElement.scrollTop || document.body.scrollTop);
			}
		},
		swiperInit(){
			// this.swiper = new Swiper('#banner-swiper',{
			// 	autoplay: {
			// 		delay: 5000,
			// 		disableOnInteraction: false,
			// 	},
			// 	loop: false,
			// 	pagination: {
			// 		el: '.swiper-pagination',
			// 		clickable:true,
			// 	},
			// })
		},
		setAdv2Index(index){
			gio('track', 'DTF2021_videoclick',{
				DTF2021_videotitle:this.adv2[index].title,
			});
			this.adv2_index = index;
			this.$nextTick(()=>{
				this.playVideo();
			})
		},
		showVideo(item){
			gio('track', 'DTF2021_videoclick',{
				DTF2021_videotitle:item.title,
			});
			item.video = item.url;
			this.video_info = item;
		},
		hideVideo(){
			this.video_info = {}
		},
		bottomToRegister(){
			gio('track', 'DTF2021_homebottom_signup');
			this.util.toLink('/register');
		},
		kvToRegister(){
			gio('track', 'DTF2021_homekv_signup');
			this.util.toLink('/login')
		},
		kvToVideo(){
			gio('track', 'DTF2021_homekv_videoplay');
			this.util.toLink('/video')
		},
		toRegister(){
			if(this.adv5.kv_status == 1){
				if(this.user_info.id){
					return false;
				}else{
					this.util.toLink('/register')
				}
			}else{
				if(this.adv5.link){
					var url = this.global.MUDU_HOST +this.adv5.link;
					if(this.user_info.id){
						var router = this.$router.resolve({
							path:"/auth",
							query:{
								live_code:this.adv5.link,
								redirect:url
							}
						});
						window.open(router.href, '_blank');
					}else{
						var from = "/auth?live_code="+this.adv5.link+"&redirect="+url
						this.util.showAuth({
							show:true,
							from:from,
							target:"_blank"
						});
					}
				}else{
					this.$router.push({
						path:"/branch"
					})
				}
			}
		},
		playVideo(id){
			var video = document.getElementById(id + '_video'),
				videos = document.querySelectorAll('video');
			video.addEventListener('play',()=>{
				this[id + '_play_show'] = false;
			})
			video.addEventListener('pause',()=>{
				this[id + '_play_show'] = true;
			})
			videos.forEach(function(item){
				if(video != item)
					item.pause();
			});
			video.play();
		},
		stopVideo(id){
			var video = document.getElementById(id + '_video');
			video.pause();
		},
		getAdv6(){
			this.http.request({
				api:"adv/getAdv",
				data:{
					position:4,
				},
				success:(res)=>{
					this.adv6 = res.adv[0];
				}
			})
		},
		getAdv5(){
			this.http.request({
				api:"adv/getAdv",
				data:{
					position:19,
				},
				success:(res)=>{
					this.adv5 = res.adv[0];
				}
			})
		},
		refresh(){
			// this.timer = setInterval(()=>{
			// 	var myDate = new Date();
			// 	var now_time = parseInt(myDate.getTime()/1000);
			// 	if(now_time == this.tool.date.strtotime('2023-08-18 09:00')){
			// 		this.getAdv5()
			// 	}
			// },1000)
		},
		getSpeakerList(){
			this.http.request({
				api:"guest/getGuestList",
				data:{
					is_top:1,
				},
				success:(res)=>{
					this.speaker = res.list;
				}
			})
		},
		getVideoList(){
			this.http.request({
				api:"video/getVideoList",
				data:{
					type:2,
				},
				success:(res)=>{
					this.adv2 = res.list;
				}
			})
			this.http.request({
				api:"video/getVideoList",
				data:{
					type:3,
				},
				success:(res)=>{
					this.adv4 = res.list;
				}
			})
		},
		createBar(){
			var end_time = "2022-08-25 09:00:00";
			end_time = this.tool.date.strtotime(end_time);
			var one = ()=>{
				var now_time = parseInt(new Date().getTime()/1000);
				var offset = end_time - now_time;
				var checkTime = (i)=>{
					if(i<10) {
						i = "0" + i;
					}
					return i;
				}
				if(offset > 0){
					var day = parseInt(offset / 60 / 60 / 24 , 10)
					var hour = parseInt(offset / 60 / 60 % 24  , 10)
					var min = parseInt(offset / 60 % 60, 10)
					var seconds = parseInt(offset % 60, 10)
					hour = checkTime(hour);
					min = checkTime(min);
					seconds = checkTime(seconds);
				}else{
					this.is_end = true;
				}
				this.cut_time = {
					day:day,
					hour:hour,
					min:min,
					seconds:seconds,
				}

				var barDay = document.querySelector('#bar-day');
				new Bar({canvasDom:barDay, r:80, lineWidth:4, angle:Math.PI*2*(day/100),duration:0, lineBgColor:'#C8C9C7', lineColor:'#376f84', showPercent:false,});
				var hourDay = document.querySelector('#bar-hour');
				new Bar({canvasDom:hourDay, r:80, lineWidth:4, angle:Math.PI*2*(hour/24),duration:0, lineBgColor:'#C8C9C7', lineColor:'#376f84', showPercent:false,});
				var minDay = document.querySelector('#bar-min');
				new Bar({canvasDom:minDay, r:80, lineWidth:4, angle:Math.PI*2*(min/60),duration:0, lineBgColor:'#C8C9C7', lineColor:'#376f84', showPercent:false,});
				var secondsDay = document.querySelector('#bar-second');
				new Bar({canvasDom:secondsDay, r:80, lineWidth:4, angle:Math.PI*2*(seconds/60),duration:0, lineBgColor:'#C8C9C7', lineColor:'#376f84', showPercent:false,})
			}
			one();
			clearInterval(this.timer);
			this.timer = setInterval(()=>{
				one();
			},1000)
			this.$once('hook:hook:beforeDestory',()=>{
				clearInterval(this.timer);
			})
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.swiperInit();
		//this.getAdv5();
		this.getAdv6();
		this.getVideoList();
		this.getSpeakerList();
		this.refresh();
		this.createBar();
		this.listenScroller();
		this.util.showBottom(true)
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
	.cover{}
    .header{position: fixed;top:0;left:0;width: 100%;height:60px;text-align: center;color: #fff;border-bottom: 1px solid rgba(255,255,255,.2);z-index: 99;background: url("~@/assets/image/2026/home-nav-bg.png") no-repeat center top;background-size: 1920px auto;opacity: 0;transition: all .3s ease;}
	.header.active{opacity: 1;transition: all .3s ease;}
    .banner-swiper{
		.swiper-container{
			.swiper-wrapper{
				.swiper-slide{
					.banner{height:460px;background: url("~@/assets/image/2026/home-kv.png") no-repeat center top;background-size:1920px 460px;text-align: center;color: #fff;position: relative;
						.center{display: inline-block;position: relative;
							.middle{height:460px;text-align: left;width: 1200px;
								.title{width: 750px;height:200px;background: url("~@/assets/image/2026/slogan01.png") no-repeat left center;background-size: contain;margin:25px 0 0 5px;}
                .zzs {
                  width: 380px; height: 27px; background: url("~@/assets/image/2026/zzs01.png") no-repeat left center;background-size: 100% auto;
                }
								.m-title{display:none;width: 970px;margin-top:-110px;
									.img{width: 326px;height:30px; background: url("~@/assets/image/83.png") no-repeat center center;background-size:contain;}
								}
								.live{position: absolute;left:5px;bottom:80px;width:177px;height:46px;text-align: center;line-height: 46px;
                  //background: url("~@/assets/image/2021/37.png") no-repeat center center ;background-size:cover;
                  background-color: #cbeeff; border-radius: 6px;
                  color:#00227F; font-weight: bold;cursor: pointer;}
								.logo{position: absolute;bottom:20px;right:0;width: 272px;height:33px;background: url("~@/assets/image/logo.png") no-repeat center center;background-size: contain;display: none;}
								.btn{ position: relative;top:40px; width: 200px; height:50px;margin: 0 auto 0;background: url("~@/assets/image/2021/37.png") no-repeat center center ;background-size:cover;text-align: center;color:#fff;font-size: 20px;line-height: 50px;transition: all .3s ease;cursor: pointer;}
								.btn:hover{background: #2d576f;transition: all .3s ease;}
							}
						}
						.logo-box{width: 1200px;height:460px;position: absolute;top:0; left:50%;margin-left: -600px; display: none;
							.box{position: absolute;bottom:30px;left:0;width: 240px;height:64px;background: url("~@/assets/image/82.png") no-repeat center center;background-size: contain;}
							.live-btn{position: absolute;bottom:30px;right:0;height:50px;padding: 0 25px;background: #a8375c;text-align: center;color:#fff;font-size: 20px;line-height: 50px;transition: all .3s ease;cursor: pointer;}
							.live-btn:hover{background: #194478;transition: all .3s ease;}
							.live-btn.hidden{cursor: default;}
							.live-btn.hidden:hover{background: #a8375c;transition: all .3s ease;}
						}
					}
					.banner2{height:460px;background: url("~@/assets/image/2021/40.jpg") no-repeat center top;background-size:1920px 460px;text-align: center;color: #fff;position: relative;
						.center{display: inline-block;position: relative;
							.middle{height:460px;text-align: left;width: 1200px;
								.title{font-size: 40px;font-weight: bold;}
								.min-title{font-size: 22px;margin-top: 20px;}
								.btn{display: block; width: 177px; height:46px;margin-top: 45px ;background: url("~@/assets/image/2021/41.png") no-repeat center center ;background-size: 100% 100%;cursor: pointer; }
							}
						}
					}
				}
			}
			.swiper-pagination{
				::v-deep .swiper-pagination-bullet{width:14px;height:8px;background: rgba(255,255,255,.4);border-radius:4px;opacity: 1;transition: all .3s ease;}
				::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active{width:24px;height:8px;background: rgba(255,255,255,1);transition: all .3s ease;}
			}
		}
	}
    .common-title{overflow:hidden;font-size: 36px;line-height: 47px;color:#C8C9C7;padding: 35px 0;text-align: center;
        .title{color:#333;}
        .en-title{margin-left: 10px;font-weight: 100;text-transform: uppercase;}
    }
    .s1{background: #fff;padding: 70px 0 30px;
        .center{width: 1200px;margin: 0 auto;
            .content{font-size: 16px;line-height: 24px;color:#444444;
                ::v-deep p{margin-top: 16px;text-indent:2em;
					i{
                        color: #0032c2; font-weight: 700;
                    }
                }
            }
			.more{text-align: center;margin-top: 30px;
				.btn{display: inline-block;font-size: 18px;color:#fff;background:  #1D56C0; padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
					span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
				}
				.btn:hover{font-weight: bold; transition: all .3s ease;}
			}
        }
    }
    .s2{padding: 17px 0 70px;background: #fff;display: none;
        .center{width: 1200px;margin: 0 auto;
            .content{overflow:hidden;
                .video{width: 866px;height:486px;background-color: #999;background-repeat: no-repeat;background-position: center center;background-size: cover;position: relative;
                    video{width: 100%;height:100%;object-fit: cover;}
                    .mark{position: absolute;width: 100%;height:100%;top:0;left:0;background: rgba(0,0,0,.5);
                        .play{position: absolute;top:50%;left:50%;width: 70px;height:70px;background: url("~@/assets/image/2021/7.png") no-repeat center center;background-size: contain;margin-top: -35px;margin-left: -35px;cursor: pointer;}
                    }
                }
                .list{width:320px;
                    .item{height:153px;height:487px;background: #ebf6ff;margin-bottom: 14px;color:#1A1A1A;position: relative;transition: all .3s ease;
                        .tit{padding: 70px 11px 0 22px;line-height:1.8;text-indent:2em;}
						.tit + .tit { padding-top:30px; }
						.tit.s2_offline { padding-top:85px; }
                        .link{width: 29px;height:12px;position: absolute;bottom:12px;right:14px;background: url("~@/assets/image/2021/9.png") no-repeat center center;background-size: contain;}
                    }
                    .item:hover{box-shadow: 0 0 10px 5px rgba(65, 182, 230, .1);transition: all .3s ease;}
                    .item.active{color:#232846; background: url("~@/assets/image/2021/8.png") no-repeat left center;background-size: 100% 100%;transition: all .3s ease;}
                    .item:nth-last-child(1){margin-bottom: 0;}
                }
            }
			.more{text-align: center;padding-top: 40px;clear: both;
				.btn{display: inline-block;font-size: 18px;color:#fff;background:  linear-gradient(90deg,#1D56C0,#1D56C0); padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
					span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
				}
				.btn:hover{font-weight: bold; transition: all .3s ease;}
			}
        }
    }
    .s3{padding: 17px 0 70px;background: #f3f3f3;position: relative;
        .center{width: 1200px;margin: 0 auto;
            .b1{width: 126px;height:126px;position: absolute;top:-50px;right:100px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: contain;}
            .common-title{margin-left: 10px;}
            .content{
                .list{overflow:hidden;padding: 10px 0;
                    .item{width: 270px;margin-right: 40px;transition: all .3s ease;
                        .image{height:270px;background: url("~@/assets/image/2024/avatar01.png") no-repeat center center;background-size: cover;
							.img{width: 100%;height:100%; background-repeat: no-repeat;background-position: center center;background-size: cover;}
						}
                        .info{padding: 24px;background: #F4F4F4;border: 2px solid #F4F4F4;border-top:none;
                            .username{font-size: 24px;line-height: 38px;}
                            .desc{-webkit-line-clamp: 4;font-size: 14px;line-height: 24px;margin-top: 8px;color:#808080;white-space:pre-line}
                        }
                    }
                    .item:nth-last-child(1){margin-right: 0;}
                    .item:hover{box-shadow: 0 0 14px 0 rgba(65,182,230,0.44);transition: all .3s ease;
                        .info{border-color: rgba(119,186,231,1);}
                    }
                }
                .more{text-align: center;margin-top:10px;margin-bottom: 30px;
                    .btn{display: inline-block;font-size: 18px;color:#fff;background: linear-gradient(90deg,#1D56C0,#1D56C0); padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
						span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
					}
                    .btn:hover{font-weight: bold; transition: all .3s ease;}
                }
            }
        }
    }
	.s4{background:#fff;position: relative;padding-top:70px;padding-bottom: 50px;
		.center{width: 1200px;margin: 0 auto;
			.content{
				.list{display: flex;
					.item{flex: 1;cursor: pointer;transition: all .3s ease;position: relative;text-align: center;
						.icon{height:100px;margin: 0 auto; }
						.info{text-align: center;margin-top: 9px;
							.tit{font-size: 26px;line-height: 50px;color:rgba(68, 68, 68, 1);font-weight: bold;}
							.m-tit{font-size: 18px;color:rgba(102, 102, 102, 1);line-height: 38px;text-transform:uppercase;}
						}
					}
					.item:nth-child(1){
						.icon{background: url("~@/assets/image/2024/icon01.png") no-repeat center center;background-size: 140px;}
					}
					.item:nth-child(2){
						.icon{background: url("~@/assets/image/2024/icon02.png") no-repeat center center;background-size: 140px;}
					}
					.item:nth-child(3){
						.icon{background: url("~@/assets/image/2024/icon07.png") no-repeat center center;background-size: 140px;}
					}
					.item:nth-child(4){
						.icon{background: url("~@/assets/image/2024/icon04.png") no-repeat center center;background-size: 140px;}
					}
					.item:nth-child(5){
						.icon{background: url("~@/assets/image/2021/6-1.png") no-repeat center center;background-size: 140px;}
					}
					.item.item-offline{
						.icon{background: url("~@/assets/image/2024/icon03.png") no-repeat center center;background-size: 140px;}
					}
				}
			}
		}
	}
    .s4_bak{background: rgba(65, 182, 230, .1);height:360px;margin-top: 200px;position: relative;
        .center{width: 1200px;margin: 0 auto;
            .b1{width: 126px;height:126px;position: absolute;bottom:-50px;left:100px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: contain;}
            .common-title{margin-left: 10px;}
            .content{
                .list{transform: translateY(-44px);padding:10px;
                    .item{width: 369px;height:250px;border-radius: 10px;box-shadow: 0 0 10px 2px rgba(0,0,0,0.1);background: #fff; margin-right: 40px;margin-bottom: 30px;cursor: pointer;transition: all .3s ease;position: relative;
                        .bg{position: absolute;top:0;left:0;width: 100%;height:100%;z-index: 1;opacity: 0; background: url("~@/assets/image/2021/11.png") no-repeat center center;background-size: cover; transition: all .3s ease;}
                        .icon{height:137px;position: relative;z-index: 1;}
                        .info{text-align: center;position: relative;z-index: 1;
                            .tit{font-size: 24px;line-height: 38px;color:#444444;}
                            .m-tit{font-size: 18px;color:#808080;line-height: 30px;text-transform:uppercase;}
                        }
                    }
                    .item:hover{box-shadow: 0 0 10px 2px rgba(65,182,230,0.44);transition: all .3s ease;
                        .bg{opacity: 1;transition: all .3s ease;}
                        .info{
                            .tit{color:#fff;}
                            .m-tit{color:#fff;}
                        }
                    }
                    .item:nth-child(3n){margin-right: 0;}
                    .item:nth-child(3n+2){margin-top: -117px;}
                    .item:nth-child(7){margin-top: -117px;margin-left: 410px;}
                    .item:nth-child(1){ .icon{background: url("~@/assets/image/2021/1.png") no-repeat center center;background-size: 85px;} }
                    .item:nth-child(2){ .icon{background: url("~@/assets/image/2021/2.png") no-repeat center center;background-size: 85px;} }
                    .item:nth-child(3){ .icon{background: url("~@/assets/image/2021/3.png") no-repeat center center;background-size: 60px;} }
                    .item:nth-child(4){ .icon{background: url("~@/assets/image/2021/4.png") no-repeat center center;background-size: 93px;} }
                    .item:nth-child(5){ .icon{background: url("~@/assets/image/2021/5.png") no-repeat center center;background-size: 94px;} }
                    .item:nth-child(6){ .icon{background: url("~@/assets/image/2021/6.png") no-repeat center center;background-size: 94px;} }
                    .item:nth-child(7){ .icon{background: url("~@/assets/image/2021/6-1.png") no-repeat center center;background-size: 94px;} }
                    .item:hover:nth-child(1){ .icon{background: url("~@/assets/image/2021/1_a.png") no-repeat center center;background-size: 85px;} }
                    .item:hover:nth-child(2){ .icon{background: url("~@/assets/image/2021/2_a.png") no-repeat center center;background-size: 85px;} }
                    .item:hover:nth-child(3){ .icon{background: url("~@/assets/image/2021/3_a.png") no-repeat center center;background-size: 60px;} }
                    .item:hover:nth-child(4){ .icon{background: url("~@/assets/image/2021/4_a.png") no-repeat center center;background-size: 93px;} }
                    .item:hover:nth-child(5){ .icon{background: url("~@/assets/image/2021/5_a.png") no-repeat center center;background-size: 94px;} }
                    .item:hover:nth-child(6){ .icon{background: url("~@/assets/image/2021/6_a.png") no-repeat center center;background-size: 94px;} }
                    .item:hover:nth-child(7){ .icon{background: url("~@/assets/image/2021/6-1_a.png") no-repeat center center;background-size: 94px;} }
                }
            }
        }
    }
    .s5{clear: both;padding: 17px 0 70px;background: #fff;position: relative;
        .center{width: 1200px;margin: 0 auto;
            .b1{width: 126px;height:126px;position: absolute;top:153px;left:-14px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: contain;}
            .common-title{margin-left: 10px;}
            .content{
                .list{overflow: hidden;padding:10px 0;display: flex;
                    .item{flex: 1; margin-right: 20px;text-align: left;transition: all .3s ease;background: #fafafa;box-shadow: 0 0 10px 2px rgb(0,0,0,.03);
                        .image-box{padding: 15px;
                            .image{height:160px;background:url("~@/assets/image/11.png") no-repeat center center;background-size: cover;position: relative;
                                .play{width: 45px;height:45px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/2021/7.png") no-repeat left center;background-size: contain;margin-left: -22px;margin-top: -22px; cursor: pointer;z-index: 2;}
                            }
                            .image::after{content: "";display: block;position: absolute;top:0;left:0;width: 100%;height:100%; background: rgba(0,0,0,.5);z-index: 1;}
                        }
                        .info{border: 1px solid #fafafa;padding:0 15px 15px;box-sizing: border-box;
							.tit{font-size: 16px;line-height: 19px;color:#1D56C0;
								i{font-weight: bold;margin-left: 2px;}
							}
							.min-tit{font-size: 14px;color:#1A1A1A;line-height: 24px;min-height:48px; -webkit-line-clamp: 2;}
                        }
                    }
					.item:hover{box-shadow: 0 0 10px 2px rgb(0,118,206,.3);}
                    .item:nth-last-child(1){margin-right: 0;}
                }
            }
			.more{text-align: center;margin-top: 30px;
				.btn{display: inline-block;font-size: 18px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f);; padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
					span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
				}
				.btn:hover{font-weight: bold; transition: all .3s ease;}
			}
        }
    }
	.s6{clear: both;padding:70px 0 17px;position: relative;
		.center{width: 1200px;margin: 0 auto;
			.content{
				.list{text-align: center;margin-top: 30px;
					.cen{display: inline-block;
						.item{width: 168px;margin-right: 118px;
							.number-box{position: relative;
								.wrapper{width: 168px;height:168px;}
								.number{position: absolute;top:0;left:0;width: 100%;height:100%;text-align: center;line-height: 168px;color:#376f84;font-size: 46px;font-weight: bold;}
							}
							.tit{text-align: center;margin-top: 14px;font-size: 30px;color:#376f84}
						}
						.item:nth-last-child(1){margin-right: 0;}
					}
				}
				.tip{font-weight: bold; font-size: 16px;color:#1a1a1a;margin-top: 50px;text-align: center;}
				.more{text-align: center;margin-top: 50px;
					.btn{display: inline-block;font-size: 18px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f);; padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
						span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
					}
					.btn:hover{font-weight: bold; transition: all .3s ease;}
				}
			}
		}
	}
    .book-success{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 1000;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8);}
        .content{position: absolute;left:50%;top:50%;width:750px;height:390px;background: url("~@/assets/image/2026/success-kv.png") no-repeat center center;background-size: cover;color: #fff;margin-left:-375px;margin-top:-195px;border-radius: 10px;
            .close{width: 50px;height:50px;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;}
            .close:hover{background-image:url("~@/assets/image/53.png");background-size: 20px; transition: background .3s ease;}
            .middle{width: 750px;height:390px;text-align: center;
                .title{font-size: 43px;}
                .m-title{font-size: 30px;margin-top: 30px;line-height: 46px;}
            }
        }
    }
</style>

